import React from "react";
import { Icon, Link, Stack, Text } from "sprint-common-web";

interface AssetsLinkSectionProps {
    href: string | undefined;
}

export const AssetsLinkSection = ({ href }: AssetsLinkSectionProps): JSX.Element => {
    return (
        <Link href={`#${href}`} testAttributes={{ "data-testid": "summary-assets-link" }} target="_blank">
            <Stack horizontal verticalAlign="center" tokens={{ padding: "0 10px 20px 0", childrenGap: 6 }}>
                <Text variant="smallPlus">Here is a link to newly created assets</Text>
                <Icon size={10} iconName={"ArrowUpRight"} />
            </Stack>
        </Link>
    );
};
